/**
 * TailwindCSS class name merger
 *
 * Extended version of tailwind-merge with custom class groups for Meetmy design system.
 * Use this instead of clsx/cn for better Tailwind class conflict resolution.
 */

import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Extended tw-merge with custom Meetmy class groups
 */
export const tw = extendTailwindMerge({
  extend: {
    classGroups: {
      // Every token in tailwind.config.js `fontSize` must be listed here. A missing one
      // isn't inert: tailwind-merge's built-in `font-size` group only recognises t-shirt
      // sizes, so an unlisted `text-pill` falls through to the *text-color* group, then
      // "conflicts" with a real color and gets dropped — silently, and only where a size
      // and a color meet in one tw(), which is why it survives review. That is how the
      // dashboard's mobile menu rows lost `text-pill` and rendered at the inherited 16px.
      'font-size': [
        'text-display-1',
        'text-display-2',
        'text-display-3',
        'text-card-display',
        'text-title-1',
        'text-title-2',
        'text-head-1',
        'text-head-2',
        'text-head-3',
        'text-p-3',
        'text-pill',
        'text-cta',
        'text-badge',
      ],
      // Custom colors (bg-midnight, bg-lime, etc.)
      'bg-color': ['bg-midnight', 'bg-lime', 'bg-error'],
      'text-color': ['text-midnight', 'text-lime', 'text-error'],
      'border-color': ['border-midnight', 'border-lime', 'border-error'],
    },
  },
});
